<template>
  <div class="workStatistics">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>工作情况统计
      </span>
      <span class="other more"></span>
    </div>
    <div class="workStatistics-main">
      <el-row>
        <el-col>
          <div class="dateChoose">
            <span :class="{ active: tabname=='week'  }" @click="tabChange('week',1)">本周</span>
            <span :class="{ active: tabname=='month'  }" @click="tabChange('month',2)">本月</span>
            <span :class="{ active: tabname=='year'  }" @click="tabChange('year',3)">本年</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 我的工作 -->
        <el-col :span="4">
          <el-row>
            <div class="mywork">我的工作</div>
          </el-row>
          <el-row>
            <div class="mywork-count">
              <svg-icon icon-class="book" class="iconstyle"></svg-icon>
              <div class="container-card-text">
                <span class="bignumFontSizeBlue" @click="enterMywork">
                  {{ myWorkCount }}
                  <span class="until">件</span>
                </span>
              </div>
            </div>
          </el-row>
        </el-col>
        <el-col class="vertaline">
          <div></div>
        </el-col>
        <!-- 平均每天办理 -->
        <el-col :span="9" class="productType">
          <el-row class="productType1">
            <el-col>
              <span class="FontSize">平均每天办理</span>
            </el-col>
          </el-row>
          <el-row class="productType3">
            <el-col :span="8" class="svgMragin">&nbsp;</el-col>
            <el-col :span="8" class="svgMragin">
              <svg-icon icon-class="read" class="iconstyle"></svg-icon>
              <span class="numFontSizeBlue" @click="enterMywork">{{ dailyWorkCount | toFixed }}</span>
              <span class="until" @click="enterMywork">件</span>
            </el-col>
            <el-col :span="8" class="svgMragin">&nbsp;</el-col>
          </el-row>
        </el-col>
        <!-- 平均每件用时 -->
        <el-col :span="10" class="productType">
          <el-row class="productType1">
            <el-col>
              <span class="FontSize">平均每件用时</span>
            </el-col>
          </el-row>
          <el-row class="productType3">
            <el-col :span="8" class="svgMragin">&nbsp;</el-col>
            <el-col :span="8" class="svgMragin">
              <svg-icon icon-class="timer" class="iconstyle"></svg-icon>
              <span class="numFontSizeBlue">{{ dailyWorkCount && 8 / dailyWorkCount | toFixed }}</span>
              <span class="until">小时</span>
            </el-col>
            <el-col :span="8" class="svgMragin">&nbsp;</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { MyWorkControllerSvr } from '@/service/MyWorkControllerSvr.js';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      tabname: 'week',
      Position: 'running',
      dailyWorkCount: 0,
      myWorkCount: 0
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    },
    ...mapState(['token','userInfo'])
  },
  created() {
    this.myWorkControllerSvr = new MyWorkControllerSvr();
  },
  mounted() {
    this.getDailyWorkload(1);
    this.getMyTaskCount();
  },
  methods: {
    // 获取总的工作数量
    getMyTaskCount () {
      this.myWorkControllerSvr.getMyTaskCount(this.token,'',4,null,null).then(res => {
        this.myWorkCount = res;
      });
    },
    // 获取日常工作数量
    getDailyWorkload(status) {
      this.myWorkControllerSvr.getDailyWorkload(this.token,this.userInfo.LoginId,status).then(res => {
        this.dailyWorkCount = res;
      });
    },
    // 切换周、月、年
    tabChange (tabname, status) {
      this.tabname = tabname;
      this.getDailyWorkload(status);
    },
    getdata() {
      this.myWorkControllerSvr.getMyTaskCount();
    },
    enterMywork() {
      this.$router.push('/myworkList');
    }
  },
  filters: {
    toFixed (value) {
      return value.toFixed(2);
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.workStatistics {
  background-color: #fff;
  .index-header {
    .more {
      color: blue;
    }
  }
  .workStatistics-main {
    background-color: #fff;
    .myChartSafeProduction-father {
      display: flex;
      height: 210px;
      align-items: center;
      justify-content: center;
    }
    .mywork {
      text-align: center;
      margin-top: 45px;
      font-family: 'MicrosoftYaHei';
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
    .mywork-count {
      display: flex;
      margin-top: 30px;
      justify-content: center;
      align-items: baseline;
    }
    .dateChoose {
      text-align: right;
      span {
        line-height: 30px;
        padding: 10px;
        font-family: 'MicrosoftYaHei';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        cursor: pointer;
      }
      .active {
        color: #0f77f2;
        border-bottom: 3px solid;
      }
    }
    .productType {
      .productType1 {
        text-align: center;
        margin-top: 40px;
      }
      .productType2 {
        text-align: center;
        margin-top: 30px;
      }
      .productType3 {
        text-align: center;
        margin-top: 20px;
        //图标对齐
        .svgMragin {
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }
      }
    }
    //长竖线
    .vertaline {
      width: 1%;
      height: 210px;
      div {
        width: 1px;
        height: 80%;
        background-color: #e2e2e2;
        margin-top: 21px;
      }
    }
    //短竖线
    .vertalineShort {
      width: 1%;
      height: 50px;
      div {
        width: 1px;
        height: 100%;
        background-color: #e2e2e2;
      }
    }
    //数字样式
    .numFontSizeBlue {
      width: 50px;
      height: 18px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
      margin-left: 6px;
      cursor: pointer;
    }
    .until {
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #0f77f2;
    }
    //数字样式
    .bignumFontSizeBlue {
      width: 54px;
      height: 29px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 34px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
      margin-left: 6px;
      cursor: pointer;
      .until {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #0f77f2;
      }
    }
    //字体样式
    .FontSize {
      width: 26px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
  }
}
</style>